import { useState } from 'react';
import { Link } from 'react-router-dom';

const NEWSLETTER_URL = 'https://readdy.ai/api/form/d7771qornr7vi0ujqkqg';

const hours = [
  { day: 'Monday', time: '9AM - 4:30PM' },
  { day: 'Tuesday', time: '9AM - 4:30PM' },
  { day: 'Wednesday', time: '9AM - 4:30PM' },
  { day: 'Thursday', time: '9AM - 4:30PM' },
  { day: 'Friday', time: '9AM - 4:30PM' },
  { day: 'Saturday', time: 'Closed' },
  { day: 'Sunday', time: 'Closed' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await fetch(NEWSLETTER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch { setSubmitted(true); }
    finally { setSubmitting(false); }
  };

  return (
    <footer className="bg-black border-t border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="bg-black px-3 py-1 rounded-md inline-block mb-5">
              <img src="https://storage.readdy-site.link/project_files/46657608-d0ca-4545-9ab2-ac2201198360/2d3839aa-5f59-4a91-aaa8-e67f58243477_Screenshot_2026-04-02_093445-removebg-preview.png?v=34241cc1f1476dc80a534b34229e9189"
                alt="Summit Appalachia Insurance" className="h-20 w-auto object-contain" />
            </div>
            <p className="text-white/50 text-sm leading-relaxed font-sans mb-6">
              Serving contractors, businesses, and families across all 50 states — with deep roots in Kentucky, Tennessee, Virginia, West Virginia, and Ohio.
            </p>
            <div className="flex items-center gap-4">
              {['ri-facebook-line', 'ri-linkedin-line', 'ri-instagram-line'].map(icon => (
                <a key={icon} href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center border border-white/10 rounded-md hover:border-[#D4AF37] hover:text-[#D4AF37] text-white/40 transition-colors cursor-pointer">
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5 font-sans">Navigation</h4>
            <ul className="space-y-3">
              {[{ label: 'Home', path: '/' }, { label: 'About Us', path: '/about' }, { label: 'Services', path: '/services' }, { label: 'Claims', path: '/claims' }, { label: 'Resources', path: '/resources' }, { label: 'Contact', path: '/contact' }].map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors font-sans cursor-pointer">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5 font-sans">Business Hours</h4>
            <ul className="space-y-2">
              {hours.map(h => (
                <li key={h.day} className="flex justify-between text-sm font-sans">
                  <span className="text-white/40">{h.day}</span>
                  <span className={h.time === 'Closed' ? 'text-white/30' : 'text-white/70'}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + Newsletter */}
          <div>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-5 font-sans">Contact</h4>
            <ul className="space-y-3 mb-7">
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-[#D4AF37]" /></div>
                <a href="mailto:John@summitappalachia.com" className="text-white/60 text-sm font-sans hover:text-[#D4AF37] transition-colors">John@summitappalachia.com</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-line text-[#D4AF37]" /></div>
                <a href="tel:6062691190" className="text-white/60 text-sm font-sans hover:text-[#D4AF37] transition-colors">606-269-1190</a>
              </li>
            </ul>
            <h4 className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest mb-3 font-sans">Stay Updated</h4>
            {submitted ? (
              <p className="text-[#c9a84c] text-sm font-sans">Thanks for subscribing!</p>
            ) : (
              <form data-readdy-form onSubmit={handleNewsletter} className="flex gap-2">
                <input type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Your email"
                  className="flex-1 bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] font-sans" />
                <button type="submit" disabled={submitting}
                  className="px-3 py-2 bg-[#D4AF37] text-black text-xs font-bold rounded-md hover:bg-[#e8c84e] transition-colors whitespace-nowrap cursor-pointer">
                  {submitting ? '...' : 'Join'}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs font-sans">&copy; 2026 Summit Appalachia Insurance LLC. All rights reserved.</p>
          <div className="flex gap-5">
            <a href="#" className="text-white/20 text-xs hover:text-[#D4AF37] transition-colors font-sans cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white/20 text-xs hover:text-[#D4AF37] transition-colors font-sans cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
